// extracted by mini-css-extract-plugin
export default {"container":"style_container__Dfxly","label":"style_label__kJ+9m"};